import { Controller } from "@hotwired/stimulus";

const HIDDEN_CLASS = "hidden";

export default class extends Controller<HTMLElement> {
    static targets = ["input", "button", "showIcon", "hideIcon", "showLabel", "hideLabel"];

    declare readonly inputTarget: HTMLInputElement;
    declare readonly buttonTarget: HTMLButtonElement;
    declare readonly showIconTarget: HTMLElement;
    declare readonly hideIconTarget: HTMLElement;
    declare readonly showLabelTarget: HTMLElement;
    declare readonly hideLabelTarget: HTMLElement;

    connect(): void {
        this.sync();
        window.setTimeout(() => this.sync(), 0);
    }

    toggle(): void {
        this.inputTarget.type = this.passwordVisible() ? "password" : "text";
        this.sync();
        this.inputTarget.focus();
    }

    sync(): void {
        const hasValue = this.inputTarget.value.length > 0;
        if (!hasValue) {
            this.inputTarget.type = "password";
        }

        const visible = this.passwordVisible();
        this.buttonTarget.classList.toggle(HIDDEN_CLASS, !hasValue);
        this.buttonTarget.setAttribute("aria-pressed", visible ? "true" : "false");
        this.showIconTarget.classList.toggle(HIDDEN_CLASS, visible);
        this.hideIconTarget.classList.toggle(HIDDEN_CLASS, !visible);
        this.showLabelTarget.classList.toggle(HIDDEN_CLASS, visible);
        this.hideLabelTarget.classList.toggle(HIDDEN_CLASS, !visible);
    }

    private passwordVisible(): boolean {
        return this.inputTarget.type === "text";
    }
}
